import { formatValue } from 'modules/core/components/ActivityLog/Log/functions'
import { ChangeValue, ChangeValueType } from 'modules/core/components/ActivityLog/Log/types'

import { Tag } from './Tag'

export const valueByType = (value: ChangeValue | undefined, isOldValue = false) => {
  if (!value) {
    return null
  }

  switch (value.type) {
    case ChangeValueType.Tag:
      return <Tag value={value} isOldValue={isOldValue} />
    default:
      return formatValue(value.value)
  }
}
